import { Mail } from 'lucide-react'
import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import { FamilyContext } from '../Context/FamilyHeadContext'
import familyHeadCustomizations from '../data/hebrewFamilyHeadStyles.json'
import { API_URL, doApiGet } from '../services/apiService'
import { convertToHebrewDate } from '../utils/HebrewDateConverter'
import i18n from "i18next";

const Footer = () => {
  const [currentVisitors, setCurrentVisitors] = useState(0)
  const [totalVisitors, setTotalVisitors] = useState(0)
  const [error, setError] = useState(null)
  const [lastUpdate, setLastUpdate] = useState(null)
  const { t } = useTranslation() // שינוי כאן
  const { pathPrefix } = useContext(FamilyContext)

  useEffect(() => {
    const fetchVisitorsData = async () => {
      try {
        const [currentRes, totalRes, lastUpdateRes] = await Promise.all([
          doApiGet(`${API_URL}/user-count/current`),
          doApiGet(`${API_URL}/user-count/total`),
          doApiGet(`${API_URL}/user-count/last-update`),
        ])

        setCurrentVisitors(currentRes || 0)
        setTotalVisitors(totalRes?.totalConnections || 0)
        setLastUpdate(lastUpdateRes?.lastUpdate || null)
        setError(null)
      } catch (err) {
        console.error('Error fetching visitors data:', err)
        setError('שגיאה בטעינת נתוני המבקרים')
      }
    }

    fetchVisitorsData()
    const interval = setInterval(fetchVisitorsData, 60000)
    return () => clearInterval(interval)
  }, [])

  const { currentFamilyHead } = useContext(FamilyContext)
  const [activeStyle, setActiveStyle] = useState(
      familyHeadCustomizations[currentFamilyHead.nickname],
  )

  const dynamicStyles = {
    footer: {
      background: Array.isArray(activeStyle.backgroundColor)
          ? `linear-gradient(to bottom, ${activeStyle.backgroundColor[0]}, ${activeStyle.backgroundColor[1]})`
          : `linear-gradient(to bottom, ${activeStyle.backgroundColor}, ${activeStyle.backgroundColor}cc)`,
    },
  }

  useEffect(() => {
    setActiveStyle(familyHeadCustomizations[currentFamilyHead.nickname])
  }, [currentFamilyHead])

  return (
      <footer style={dynamicStyles.footer} className="w-full py-12 px-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Visitors Stats */}
            <div className="flex flex-col items-center md:items-start space-y-4 p-8 bg-[#8b5e3c1a] rounded-2xl shadow-lg border-2 border-[#D4B797]/20">
              <h4 className="font-heebo text-2xl font-bold text-[#5C4033]">
                {t('footer.title')}
              </h4>
              {error ? (
                  <p className="text-red-600 font-heebo">{error}</p>
              ) : (
                  <div className="space-y-3 text-center font-heebo md:text-right w-full">
                    <p className="text-[#8B5E3C] text-lg font-heebo">
                        {t('footer.nowVisitors')}
                  <span className="font-heebo font-bold text-[#5C4033] text-xl">
                    {currentVisitors}
                  </span>{' '}
                    </p>
                    <p className="text-[#8B5E3C] text-lg font-heebo">
                        {t('footer.totalVisitors')}
                  <span className="font-heebo font-bold text-[#5C4033] text-xl">
                    {totalVisitors.toLocaleString()}
                  </span>{' '}
                    </p>
                    {lastUpdate && (
                        <p className="text-[#8B5E3C] text-lg font-heebo">
                            {t('footer.lastUpdate')}
                            <span className="font-heebo font-bold text-[#5C4033] text-xl">
            {convertToHebrewDate(lastUpdate, i18n.language)}
        </span>
                        </p>
                    )}
                  </div>
              )}
            </div>

            {/* Contact Info */}
            <div
                className="flex flex-col items-center md:items-start space-y-4 p-8 bg-[#8b5e3c1a] rounded-2xl shadow-lg border-2 border-[#D4B797]/20">
              <h4 className="font-heebo text-2xl font-bold text-[#5C4033]">
                {t('footer.contact')}
              </h4>
              <Link
                  to={`${pathPrefix}about`}
                  className="flex items-center gap-3 text-lg text-[#8B5E3C] hover:text-[#5C4033] transition-colors duration-300 hover:scale-105 transform"
              >
                <Mail className="w-6 h-6"/>
                <span className="font-medium font-heebo">harel@bazach.com</span>
              </Link>
            </div>
          </div>

          {/* Footer Bottom Border */}
          <div className="relative mt-12">
            <div
                className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#D4B797]/0 via-[#D4B797]/50 to-[#D4B797]/0"></div>
          </div>

          {/* Credits at bottom */}
          <div className="border-t border-[#D4B797]/30 pt-4">
            <div className="flex flex-col items-center gap-2 text-[#8B5E3C] font-heebo">
              <div className="flex flex-col md:flex-row items-center gap-2">
                <p className="text-lg">{t('footer.development')}</p>
                <span className="hidden md:inline mx-2">•</span>
                <p className="text-lg">© {t('footer.rights')}</p>
              </div>
              <p className="text-md text-[#8B5E3C]/50 transform transition-opacity hover:opacity-75">
                {t('footer.orginalSite')}
              </p>
            </div>
          </div>
        </div>
      </footer>
  )
}

export default Footer